import React from 'react';
import styles from './Sidebar.module.css';

export function Sidebar({ children }) {
  return (
    <aside className={styles.sidebar} aria-label="Organization sidebar">
      {children}
    </aside>
  );
}
